/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFreeNightCreditRequest
 */
export interface CreateFreeNightCreditRequest {
    /**
     * Link to a loyalty account if applicable
     * @type {string}
     * @memberof CreateFreeNightCreditRequest
     */
    loyaltyAccountId?: string | null;
    /**
     * e.g. Marriott Bonvoy, World of Hyatt
     * @type {string}
     * @memberof CreateFreeNightCreditRequest
     */
    programName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeNightCreditRequest
     */
    creditType: CreateFreeNightCreditRequestCreditTypeEnum;
    /**
     * Total credits earned
     * @type {number}
     * @memberof CreateFreeNightCreditRequest
     */
    totalCount: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateFreeNightCreditRequest
     */
    expirationDate: Date;
    /**
     * Points-cap per redemption (e.g. 35000 / 50000 for Marriott)
     * @type {number}
     * @memberof CreateFreeNightCreditRequest
     */
    pointsCap?: number | null;
    /**
     * Category cap (Hyatt — 4 for Cat 1-4, 7 for Cat 1-7)
     * @type {number}
     * @memberof CreateFreeNightCreditRequest
     */
    categoryCap?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFreeNightCreditRequest
     */
    topUpAllowed?: boolean;
    /**
     * Whether expiration reminders fire for this credit (GON-5964). Defaults true.
     * @type {boolean}
     * @memberof CreateFreeNightCreditRequest
     */
    remindersEnabled?: boolean;
    /**
     * Optional notes about these credits
     * @type {string}
     * @memberof CreateFreeNightCreditRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const CreateFreeNightCreditRequestCreditTypeEnum = {
    MarriottFreeNight: 'marriott_free_night',
    HiltonFreeNight: 'hilton_free_night',
    HyattFreeNight: 'hyatt_free_night',
    IhgFreeNight: 'ihg_free_night',
    WyndhamFreeNight: 'wyndham_free_night'
} as const;
export type CreateFreeNightCreditRequestCreditTypeEnum = typeof CreateFreeNightCreditRequestCreditTypeEnum[keyof typeof CreateFreeNightCreditRequestCreditTypeEnum];


/**
 * Check if a given object implements the CreateFreeNightCreditRequest interface.
 */
export function instanceOfCreateFreeNightCreditRequest(value: object): value is CreateFreeNightCreditRequest {
    if (!('programName' in value) || value['programName'] === undefined) return false;
    if (!('creditType' in value) || value['creditType'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    return true;
}

export function CreateFreeNightCreditRequestFromJSON(json: any): CreateFreeNightCreditRequest {
    return CreateFreeNightCreditRequestFromJSONTyped(json, false);
}

export function CreateFreeNightCreditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFreeNightCreditRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'],
        'creditType': json['credit_type'],
        'totalCount': json['total_count'],
        'expirationDate': (new Date(json['expiration_date'])),
        'pointsCap': json['points_cap'] == null ? undefined : json['points_cap'],
        'categoryCap': json['category_cap'] == null ? undefined : json['category_cap'],
        'topUpAllowed': json['top_up_allowed'] == null ? undefined : json['top_up_allowed'],
        'remindersEnabled': json['reminders_enabled'] == null ? undefined : json['reminders_enabled'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateFreeNightCreditRequestToJSON(json: any): CreateFreeNightCreditRequest {
    return CreateFreeNightCreditRequestToJSONTyped(json, false);
}

export function CreateFreeNightCreditRequestToJSONTyped(value?: CreateFreeNightCreditRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'credit_type': value['creditType'],
        'total_count': value['totalCount'],
        'expiration_date': value['expirationDate'].toISOString().substring(0,10),
        'points_cap': value['pointsCap'],
        'category_cap': value['categoryCap'],
        'top_up_allowed': value['topUpAllowed'],
        'reminders_enabled': value['remindersEnabled'],
        'notes': value['notes'],
    };
}

